// src/pages/ActivityPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { api } from "../api";
import ActivityCard from "../components/ActivityCard";
import BackButton from "../components/BackButton";

export default function ActivityPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [activity, setActivity] = useState(null);
  const [me, setMe] = useState(null);
  const [error, setError] = useState("");

  const returnTo = params.get("returnTo");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token") || null;
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

    const load = async () => {
      setError("");
      try {
        const [aRes, meRes] = await Promise.allSettled([
          api.get(`/activities/${id}`, { headers }),
          api.get("/users/me", { headers }),
        ]);
        if (aRes.status === "fulfilled") setActivity(aRes.value?.data || null);
        else throw new Error("Activity not found");

        if (meRes.status === "fulfilled") setMe(meRes.value?.data || null);
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || "Failed to load.");
      }
    };
    load();
  }, [id]);

  const onClose = () => {
    if (returnTo) navigate(returnTo, { replace: true });
    else navigate(-1);
  };

  return (
    <div
      className="min-h-[100svh] bg-blue-50 flex flex-col"
      style={{
        paddingTop: "env(safe-area-inset-top, 0px)",
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
        {/* Sticky back header only */}
        <div
        className="
            sticky top-0 z-10 
            bg-blue-50 backdrop-blur 
            flex items-center justify-between
            px-2 py-[1px]      /* tighter padding: 4px top/bottom */
        "
        style={{
            minHeight: "40px", // ensures tap-safe height even on iOS
            paddingTop: "env(safe-area-inset-top, 0px)",
        }}
        >
        <BackButton onClick={onClose} ariaLabel="Back" />
        </div>

      {/* Body matches feed container widths/padding */}
      <main className="w-full max-w-3xl mx-auto px-4 sm:px-6 md:px-8 py-4 md:py-6">
        {error && (
          <p className="text-red-600 text-sm mb-3 bg-white rounded-xl px-3 py-2">
            {error}
          </p>
        )}

        {activity ? (
          <div className="bg-white rounded-2xl p-0">
            {/* Use the exact same component as the feed. No extra wrappers/styles. */}
            <div className="p-6">
              <ActivityCard
                key={activity.id}
                activity={activity}
                currentUser={me}
                onUpdated={(a) => setActivity(a)}
              />
            </div>
          </div>
        ) : (
          !error && (
            <div className="text-sm text-gray-500">Loading…</div>
          )
        )}
      </main>
    </div>
  );
}
